/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

export type TTesselatedArea = { offset: { x: number; y: number }; size: { rows: number; cols: number }; level: number };

export default
function  TesselatedArea(aLevel: number, aOffsetX: number, aOffsetY: number, aCols: number, aRows: number): TTesselatedArea {
    return {
        level: aLevel,
        offset: {
            x: aOffsetX,
            y: aOffsetY
        },
        size: {
            cols: aCols,
            rows: aRows
        }
    };
}
